export interface IAboutIcons {
  imgUrl: string;
  title?: string;
  description: string;
}

export interface IAboutTab {
  id: string;
  title: string;
  videoId?: string;
  image?: string;
  firstColumnParagraphs?: string[];
  secondColumnParagraphs?: string[];
  icons?: IAboutIcons[];
}

export interface IAbout {
  title: string;
  tabs: IAboutTab[];
}

export const about: IAbout = {
  title: 'О компании',
  tabs: [
    {
      id: 'main',
      title: 'Главное',
      image: 'https://cdn.cian.site/media/images/pik-landing_images/pik-landing_about-main.jpeg',
      firstColumnParagraphs: [
        'ПИК — технологическая компания и крупнейший девелопер в России.',
        'В основе нашей работы — стремление сделать жизнь людей лучше. Собственное производство, масштаб компании и разнообразный опыт специалистов нашей команды позволяет реализовать этот подход в каждом проекте.',
        'Мы верим, что комфортная и безопасная среда, современные дома и полезные сервисы являются фундаментом счастливой жизни.',
        'Проектирование и строительство жилых районов подчинено ПИК-стандарту. Это правила, по которым мы строим наши проекты: уютные дворы-парки, современные школы и детские сады, квартиры с функциональными планировками.',
        'У нас строгие стандарты и огромные масштабы строительства, но мы не забываем, что у каждого проекта должна быть своя изюминка.',
        'Чтобы дети как можно больше времени проводили на улице, мы придумали особый формат игровых площадок — PlayHub. Каждая из них с уникальным ландшафтом и игровыми плотинами на искусственном ручье. А благодаря абстрактным формам игрового оборудования дети могут придумать бесконечное количество игр.',
      ],
      secondColumnParagraphs: [
        'Ещё одна особенность наших проектов — сухие фонтаны. У такого типа фонтанов нет традиционной чаши, а струи воды бьют прямо из тротуара, по которому можно гулять. Устраивать такие прогулки уже можно в проекте Green park, а совсем скоро в «Матвеевском парке» и Vangarden.',
        'Проекты ПИК+ отличает особое внимание к архитектурным решениям и высококачественная отделка. Ещё в таких домах — интересные и необычные планировки. Это может быть квартира со спальней, где есть отдельная ванная комната, или планировка с просторной кухней-гостиной, с двумя санузлами, с гардеробной или постирочной.',
        'ПИК — это компания про новые решения и технологии. Мы любим свежие идеи и готовы меняться во имя лучшего результата. Наша цель — доступное и качественное жильё для как можно большего количества людей.',
      ],
    },
    {
      id: 'facts',
      title: 'Факты',
      icons: [
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_buildings.svg',
          description: 'Более 27 млн м² построено с начала деятельности',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_regions.svg',
          description: 'Москва и область — крупнейший регион присутствия',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_bank-price.svg',
          description: 'Более 16 млн м² составляет земельный банк ПИК',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_raiting-a.svg',
          description: 'Рейтинг НКР на уровне A+.ru, прогноз по рейтингу «позитивный»',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_people.svg',
          description: 'Более 2 млн человек проживают в квартирах от ПИК',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_infrastructure.svg',
          description: '21 школа и 44 детских сада построено с начала деятельности ПИК',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_child-places.svg',
          description: '31 тысяча детей обучаются в школах и детских садах, построенных ПИК',
        },
      ],
    },
    {
      id: 'history',
      title: 'История',
      icons: [
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_stars.svg',
          title: '1994',
          description: 'Создание «Первой Ипотечной Компании» (ПИК)',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_mortgage.svg',
          title: '1998',
          description: 'Запуск ипотечных программ совместно с Правительством Москвы и банками-партнёрами',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_combine.svg',
          title: '2001',
          description: 'Приобретение московского Домостроительного комбината №2 (ДСК−2)',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_market.svg',
          title: '2004',
          description: 'Выход на рынки Московской и Ростовской областей',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_bank-price.svg',
          title: '2005',
          description: 'Приобретение московского Домостроительного комбината №3 (ДСК−3)',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_earth.svg',
          title: '2007',
          description:
            'Выход на международный финансовый рынок: успешное первичное размещение акций на Лондонской Фондовой бирже (LSE), РТС и ММВБ',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_guarantee.svg',
          title: '2009',
          description: 'Получение государственных гарантий Правительства Российской Федерации',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_raiting-a.svg',
          title: '2012',
          description:
            'Получение индивидуального рейтинга кредитоспособности на уровне «А» от Национального рейтингового агентства (НРА)',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_reward.svg',
          title: '2014',
          description:
            'ПИК признан лучшим девелопером жилой недвижимости в России по версии британского журнала Euromoney',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_easy-navigation.svg',
          title: '2015',
          description:
            'Вывод на рынок принципиально новых типов домов с улучшенными эстетическими и потребительскими характеристиками',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_leader.svg',
          title: '2016',
          description: 'ПИК приобрел ГК «Мортон» и стал лидером строительной отрасли',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_diagrams.svg',
          title: '2017',
          description: 'Построены рекордные 2 млн м² (29 000 квартир)',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_new-place.svg',
          title: '2018',
          description: 'Компания запустила первый проект в новом регионе — «Озёрный парк» в Тюмени.',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_card.svg',
          title: '2019',
          description: 'Впервые на российском рынке введена онлайн-оплата покупки недвижимости банковской картой',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_online.svg',
          title: '2020',
          description:
            'Отказ от офисов продаж, адаптация онлайн-процесса покупки квартиры под нужды покупателей. Запуск ипотечных онлайн-сделок.',
        },
        {
          imgUrl: 'https://cdn.cian.site/media/images/pik-landing_images/icons/pik-landing_brand.svg',
          title: '2021',
          description:
            'Запуск под собственным брендом производства мебели, которой будут комплектоваться квартиры в проектах ПИК.',
        },
      ],
    },
  ],
};
